import { AvatarWithUsername } from '@tryhackme/thm-ui-components';
import { Writeup } from 'src/features/room/components/writeup-modals/writeup-modal.types';
import { StyledColumn, StyledContainer, StyledRow, StyledTable, StyledTableContainer, StyledWriteupLink } from './write-ups-table.styles';
const TableRow = ({
  row,
  isModal
}: {
  row: Writeup;
  isModal?: boolean;
}) => {
  const {
    title,
    link,
    username,
    avatar
  } = row;
  return <StyledRow data-sentry-element="StyledRow" data-sentry-component="TableRow" data-sentry-source-file="write-ups-table.tsx">
      <StyledColumn $isModal={isModal} data-sentry-element="StyledColumn" data-sentry-source-file="write-ups-table.tsx">
        <StyledWriteupLink href={link} target="_blank" rel="noreferrer" data-sentry-element="StyledWriteupLink" data-sentry-source-file="write-ups-table.tsx">
          {title}
        </StyledWriteupLink>
      </StyledColumn>
      <StyledColumn $isModal={isModal} data-sentry-element="StyledColumn" data-sentry-source-file="write-ups-table.tsx">
        <StyledContainer key={username} data-sentry-element="StyledContainer" data-sentry-source-file="write-ups-table.tsx">
          <AvatarWithUsername username={username} avatar={avatar} data-sentry-element="AvatarWithUsername" data-sentry-source-file="write-ups-table.tsx" />
        </StyledContainer>
      </StyledColumn>
    </StyledRow>;
};
export const WriteUpsTable = ({
  writeupData,
  columnHeaders,
  isModal
}: {
  writeupData: Writeup[];
  columnHeaders: string[];
  isModal?: boolean;
}) => <StyledTableContainer $isModal={isModal} data-sentry-element="StyledTableContainer" data-sentry-component="WriteUpsTable" data-sentry-source-file="write-ups-table.tsx">
    <StyledTable data-sentry-element="StyledTable" data-sentry-source-file="write-ups-table.tsx">
      <tbody>
        <StyledRow data-sentry-element="StyledRow" data-sentry-source-file="write-ups-table.tsx">
          {columnHeaders?.map((rowItem, index) =>
        // eslint-disable-next-line react/no-array-index-key
        <StyledColumn key={`${index}`} $isModal={isModal}>
              {rowItem}
            </StyledColumn>)}
        </StyledRow>
        {writeupData?.map(row => <TableRow row={row} key={row.username} isModal={isModal} />)}
      </tbody>
    </StyledTable>
  </StyledTableContainer>;